import GlobalFunctions from '@/global'

/**
 * Call to API to get the Admin PIN.
 * @function
 * @param {object} userId - ID of the user to get the PIN for.
 * @returns {object} A promise that will return either a success object or an error object.
 */
export const getAdminPIN = function (userId) {
  return new Promise(function (resolve, reject) {
    GlobalFunctions.$ajax({
      method: 'GET',
      url: `/application/admin/${userId}/getPin`,
      success: (response) => resolve(response),
      error: (error) => {
        if (
          error &&
          error.responseJSON &&
          error.responseJSON.message === 'Admin Pin not found.'
        ) {
          resolve({
            payload: {
              pin: ''
            }
          })
        } else {
          reject(error)
        }
      }
    })
  })
}

/**
 * Call to API to create or update the Admin PIN.
 * @function
 * @param {object} data - The PIN.
 * @returns {object} A promise that will return either a success object or an error object.
 */
export const upsertAdminPIN = function (data) {
  return new Promise(function (resolve, reject) {
    GlobalFunctions.$ajax({
      method: 'POST',
      url: '/application/admin/generatePin',
      data,
      success: (response) => resolve(response),
      error: (error) => reject(error)
    })
  })
}

/**
 * Call to API to validate the Admin PIN.
 * @function
 * @param {object} data - The PIN and email to validate it against.
 * @returns {object} A promise that will return either a success object or an error object.
 */
export const validateAdminPIN = function (data) {
  return new Promise(function (resolve, reject) {
    GlobalFunctions.$ajax({
      method: 'POST',
      url: '/application/admin/validatePin',
      data,
      success: (response) => resolve(response),
      error: (error) => reject(error)
    })
  })
}

/**
 * Call to API to delete the Admin PIN.
 * @function
 * @returns {object} A promise that will return either a success object or an error object.
 */
export const deleteAdminPIN = function () {
  return new Promise(function (resolve, reject) {
    GlobalFunctions.$ajax({
      method: 'DELETE',
      url: '/application/admin/deletePin',
      success: (response) => resolve(response),
      error: (error) => reject(error)
    })
  })
}

export default {
  upsertAdminPIN,
  validateAdminPIN,
  getAdminPIN,
  deleteAdminPIN
}